import { connect } from "react-redux";

import { AppDispatch, RootState } from "../store";
import { PageAboutWeb } from "senac-components/dist/pages/Web/PageAbout";

const mapState = (state: RootState) => {
  const authenticatedUser = state.userState.user != undefined;

  return {
    authenticatedUser,
  };
};

const mapDispatch = (dispatch: AppDispatch) => {
  return {};
};

const WPageAbout = connect(mapState, mapDispatch)(PageAboutWeb);
export { WPageAbout };
